import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/auth';

import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PagesIcon from '@material-ui/icons/Pages';
import HomeIcon from '@material-ui/icons/Home';
import {Link} from 'react-router-dom';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import CreateIcon from '@material-ui/icons/Create';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import AppsIcon from '@material-ui/icons/Apps';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },

  maintoolbar: {
    background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7)'
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },

  menuitem: {
    textDecoration: 'none',
    color: '#303030'
  },

  exitbutton: {
    float: 'right'
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  accountMenu: {
    marginLeft: "auto",
    float: "right",
    color: "white"
  }

}));



function SideBar({signOutUser, match: {params: {projectId}}}) {
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [openCollapse, setOpenCollapse] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);


    const handleDrawerOpen = () => {
      setOpen(true);
    };

    const handleDrawerClose = () => {
      setOpen(false);
    };

    const clickOut = () => {
      signOutUser()
    }

    const onMouseSidebarEnter = () => {
      setOpen(true)
      setOpenCollapse(true)
    }

    const onMouseSidebarLeave = () => {
      setOpen(false)
      setOpenCollapse(false)
    }

    const handleClick = event => {
    setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const clickCollapse = () => {
      setOpen(true)
      setOpenCollapse(!openCollapse)
    }


    return (
      <>
        <CssBaseline />
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open,
          })}
        >
          <Toolbar
            className={classes.maintoolbar}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuButton, {
                [classes.hide]: open,
              })}

            >
              <MenuIcon />
            </IconButton>


            <Link
              to = {'/'}
              className={classes.menuitem}>
              <Typography variant="h6" noWrap style={{color: 'white'}}>
                Marketing Tools App
              </Typography>
            </Link>

            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
              className={classes.accountMenu}

              >
              Account
            </Button>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={() => clickOut()}>
                  <ExitToAppIcon/>
                  Logout
                </MenuItem>
              </Menu>


          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            }),
          }}
          onMouseEnter={() => onMouseSidebarEnter()}
          onMouseLeave={() => onMouseSidebarLeave()}
        >
          <div className={classes.toolbar}>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </div>
        <Divider />
        <List>
          <Link
            to = {'/project'}
            className={classes.menuitem}
            >
            <ListItem button>
              <ListItemIcon>
                <HomeIcon/>
              </ListItemIcon>
              <ListItemText primary={'Home'} />
            </ListItem>
          </Link>
          <Link
            to = {`/project/${projectId}/`}
            className={classes.menuitem}
            onClick={() => onMouseSidebarLeave()}>
            <ListItem button>
              <ListItemIcon>
                <PagesIcon/>
              </ListItemIcon>
              <ListItemText primary={'Project'} />
            </ListItem>
          </Link>
          <Link
            to = {`/project/${projectId}/update`}
            className={classes.menuitem}
            onClick={() => onMouseSidebarLeave()}>
            <ListItem button>
              <ListItemIcon>
                <CreateIcon/>
              </ListItemIcon>
              <ListItemText primary={'Settings'} />
            </ListItem>
          </Link>
          <ListItem button onClick={() => clickCollapse()}>
            <ListItemIcon>
              <AppsIcon/>
            </ListItemIcon>
            <ListItemText primary={'Apps'} />
            {openCollapse ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openCollapse} timeout="auto" unmountOnExit>
            <Link
              to = {`/project/${projectId}/strategymap`}
              className={classes.menuitem}
              onClick={() => onMouseSidebarLeave()}>
              <List component="div" disablePadding>
                <ListItem button className={classes.nested}>
                  <ListItemText primary="As-Is Strategy Canvas" />
                </ListItem>
              </List>
            </Link>
            <Link
              to = {`/project/${projectId}/buyermap`}
              className={classes.menuitem}
              onClick={() => onMouseSidebarLeave()}>
              <List component="div" disablePadding>
                <ListItem button className={classes.nested}>
                  <ListItemText primary="Buyer Map" />
                </ListItem>
              </List>
            </Link>
            <Link
              to = {`/project/${projectId}/noncustomers`}
              className={classes.menuitem}
              onClick={() => onMouseSidebarLeave()}>
              <List component="div" disablePadding>
                <ListItem button className={classes.nested}>
                  <ListItemText primary="NonCustomers" />
                </ListItem>
              </List>
            </Link>
            <Link
              to = {`/project/${projectId}/errc`}
              className={classes.menuitem}
              onClick={() => onMouseSidebarLeave()}>
              <List component="div" disablePadding>
                <ListItem button className={classes.nested}>
                  <ListItemText primary="ERRC" />
                </ListItem>
              </List>
            </Link>
            <Link
              to = {`/project/${projectId}/tobestrategymap`}
              className={classes.menuitem}
              onClick={() => onMouseSidebarLeave()}>
              <List component="div" disablePadding>
                <ListItem button className={classes.nested}>
                  <ListItemText primary="To-Be Strategy Canvas" />
                </ListItem>
              </List>
            </Link>
          </Collapse>
        </List>
        </Drawer>
      </>
    );
}

const mapStateToProps = state => state.project;

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps,
)(SideBar)
